const userInquiryEndpoints = {
  addInquiry: {
    method: "POST",
    url: `/landing-page/send-message`,
  },
  getInquiryList: {
    method: "GET",
    url: `/inquiry`,
  },
};

export default userInquiryEndpoints;
